import api from './api';

const ROLE_NAV = {
  Admin: ['/', '/consumers', '/readings', '/billing', '/payments', '/notices', '/reports', '/rates', '/ledger', '/import', '/users'],
  Cashier: ['/', '/consumers', '/readings', '/billing', '/payments', '/notices', '/ledger'],
  'Meter Reader': ['/', '/consumers', '/readings', '/reader'],
};

export function getUser() {
  const raw = localStorage.getItem('auth_user');
  return raw ? JSON.parse(raw) : null;
}

export function getToken() {
  return localStorage.getItem('auth_token');
}

export function isLoggedIn() {
  return !!getToken();
}

export function getAllowedPaths() {
  const user = getUser();
  return user ? (ROLE_NAV[user.role] || []) : [];
}

export function hasAccess(path) {
  const allowed = getAllowedPaths();
  return allowed.some(p => path === p || (p !== '/' && path.startsWith(p + '/')));
}

export async function login(username, password) {
  const { data } = await api.post('/auth/login', { username, password });
  localStorage.setItem('auth_token', data.token);
  localStorage.setItem('auth_user', JSON.stringify(data.user));
  return data.user;
}

export async function logout() {
  try {
    await api.post('/auth/logout');
  } catch (_) {}
  localStorage.removeItem('auth_token');
  localStorage.removeItem('auth_user');
  window.location.href = '/login';
}

export async function verifySession() {
  try {
    const { data } = await api.get('/auth/me');
    localStorage.setItem('auth_user', JSON.stringify(data.user));
    return data.user;
  } catch (_) {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
    return null;
  }
}
